import api from './api.service';

export interface ExternalApiKey {
  id: string;
  company_id: string;
  name: string;
  key_prefix: string;
  scopes: string[];
  is_active: boolean;
  expires_at: string | null;
  last_used_at: string | null;
  last_used_ip: string | null;
  created_by: string | null;
  created_at: string;
  revoked_at: string | null;
  revoked_by: string | null;
}

export interface CreatedExternalApiKey extends ExternalApiKey {
  /** Shown once — never retrievable again. */
  plain_key: string;
}

export const externalApiKeyService = {
  async list(): Promise<ExternalApiKey[]> {
    const res = await api.get<ExternalApiKey[]>('/company/api-keys');
    return res.data ?? [];
  },

  async create(input: { name: string; expires_at?: string | null }): Promise<CreatedExternalApiKey> {
    const res = await api.post<CreatedExternalApiKey>('/company/api-keys', {
      name: input.name,
      scopes: ['directory.read'],
      expires_at: input.expires_at ?? null,
    });
    return res.data as CreatedExternalApiKey;
  },

  async revoke(id: string): Promise<void> {
    await api.post(`/company/api-keys/${id}/revoke`);
  },
};
